import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { mailSearchStore as searchStoreV2 } from 'owa-mail-search';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getPersonaPillSuggestionsInSearchTable } from './getPersonaPillSuggestionsInSearchTable';
export function getHeaderPersonaData(isSearchTable, tableViewId, selectedNode) {
    var personaId;
    var displayName;
    var email;
    var origin;
    var mailboxType;
    var personaNode = selectedNode;
    if (isSearchTable) {
        var isFavoritePersonaFallbackSearch = personaNode.type === 1 /* Persona */ &&
            !personaNode.isSearchFolderPopulated;
        if (isFavoritePersonaFallbackSearch) {
            personaId = personaNode.personaId;
            displayName = personaNode.displayName;
            email = personaNode.mainEmailAddress;
            origin = 'PersonaHeaderFromFallbackSearch';
        }
        else {
            var searchStore = isMailFeatureEnabled('sea-commonSearchBox')
                ? searchStoreV2
                : searchStoreV1;
            var personaPill = getPersonaPillSuggestionsInSearchTable(tableViewId)[0];
            var isPreviousNodePersona = searchStore.previousNode &&
                searchStore.previousNode.type === 1 /* Persona */;
            personaId = undefined;
            displayName = personaPill.DisplayName;
            email = personaPill.EmailAddresses[0];
            mailboxType = personaPill.MailboxType;
            origin = isPreviousNodePersona
                ? 'PersonaHeaderFromPersonaSearch'
                : 'PersonaHeaderFromFolderSearch';
        }
    }
    else {
        personaId = personaNode.personaId;
        displayName = personaNode.displayName;
        email = personaNode.mainEmailAddress;
        origin = 'PersonaHeader';
    }
    return {
        personaId: personaId,
        displayName: displayName,
        email: email,
        origin: origin,
        mailboxType: mailboxType,
    };
}
//# sourceMappingURL=getHeaderPersonaData.js.map